





























































































































































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import TestQuestion from "@/store/entities/testQuestion";
import url from "@/lib/url";
//import ewebeditor from "@/components/ewebeditor.vue";
import QuestionOfPaperType from "@/store/entities/questionOfPaperTypes";
import RepeatTestQuestion from "./repeat-testQuestion.vue";
@Component({
  components: { RepeatTestQuestion },
})
export default class EditTestQuestion extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: Boolean;
  testQuestion: TestQuestion = new TestQuestion();
  repeatModalShow: boolean = false;
  questionOfPaperType: QuestionOfPaperType = new QuestionOfPaperType();
  formTitle: string = "添加试题";
  keywords: string = "";
  topicData: any = [];
  isCreate: boolean = true;
  onequestype: string = "";
  data: any = [];
  valueArray: any = [];
  parentId?: number;
  screenWidth: number = document.body.clientWidth - 200;
  mobilescreenWidth: string = "100%";
  parentName: string = "一级分类";
  editorConfig: any = {
    style: 'mini',
    width: '100%',
    height: '100px'
  };
  editorContentConfig: any = {
    style: 'coolblue',
    width: '100%',
    height: '300px'
  };
  frontendurl: string = 'https://manage.sxjy.cq.cn/dist/ewebeditor/';
  editorBackendurl: string = 'https://manage.sxjy.cq.cn/dist/ewebeditor/';
  isAudit: any = [
    { id: "true", value: "通过审核" },
    { id: "false", value: "未通过审核" },
  ];
  pdu: any = [
    { id: "True", value: "对" },
    { id: "False", value: "错" },
  ];
  difficultNamevar: any = [
    { id: 1, value: "易(A)" },
    { id: 2, value: "中(B)" },
    { id: 3, value: "难(C)" },
  ];
  blanksnum: number = 1;
  choicenum: number = 1;
  blanksnumdata: any = [
    //填空
    { id: 1, value: "5项" },
    { id: 2, value: "10项" },
    { id: 3, value: "15项" },
  ];
  choicenumdata: any = [
    //单选
    { id: 1, value: "5项" },
    { id: 2, value: "10项" },
  ];

  newtabdata: any = [
    { id: 0, value: "判断题", display: true },
    { id: 1, value: "单选题", display: true },
    { id: 2, value: "多选题", display: true },
    { id: 3, value: "填空题", display: true },
    { id: 4, value: "计算题", display: true },
    { id: 8, value: "解答题", display: true },
    { id: 9, value: "作文题", display: true },
    { id: 10, value: "探究题", display: true },
    { id: 11, value: "材料题", display: true },
    { id: 12, value: "实践题", display: true },
    { id: 7, value: "选考单选", display: false },
    { id: 5, value: "选考多选", display: false },
    { id: 6, value: "选考计算", display: false },
  ];
  keytype: string = "";
  keychecktype: any = [];
  questionTypeChange(value) {
    this.choicenum = 1;
    this.blanksnum = 1;
    this.testQuestion.questionType = value;
  }
  removefilterHtmlbr(value) {
    if (value) {
      let content = value
        .replace(/^(<[Bb][Rr]*?.*?\/?\s*?>)+/, "")
        .replace(/(<[Bb][Rr]*?.*?\/?\s*?>)+$/g, "");
      var deline = content.replace(
        /<span\sstyle="text-decoration-line:\sunderline[\s\S]*?>([\s\S]*?)<\/span>/gi,
        "<u>&nbsp;&nbsp;$1&nbsp;&nbsp;</u>"
      );
      return deline;
    } else {
      return value;
    }
  }
  removefilterHtmlp(value) {

    if (value) {

      var con1 = value.replace(/<p([\s\S]*?)>/i, "<span$1>");
      var con1 = con1.replace(/<\/p>/i, "</span>");
      return con1;
    } else {
      return value
    }


  }
  copy() {
    const clipboard = new Vue.prototype.clipboard(".btn");
    clipboard.on("success", () => {
      this.$Message.success({
        content: "复制成功",
        duration: 1,
      }); //  释放内存

      clipboard.destroy();
    });
    clipboard.on("error", () => {
      this.$Message.error({
        content: "复制失败",
        duration: 1,
      }); //  释放内存

      clipboard.destroy();
    });
  }
  //removefilterHtmlbrcont(value) {
  //^(<[Bb][Rr]*?.*?\/?\s*?>)+ 去除头部 br 带clsss
  //(<[Bb][Rr]*?.*?\/?\s*?>)+$ 去除头部 br 带clsss
  // let content = value
  //   .replace(/^(<[Bb][Rr]*?.*?\/?\s*?>)+/, "").replace(/(<[Bb][Rr]*?.*?\/?\s*?>)+$/g, "");
  // return content;
  //}

  choicenumChange(value) {
    this.choicenum = value;
    if (value == 2) {
      this.testQuestion.answerKeyF = "";
      this.testQuestion.answerKeyG = "";
      this.testQuestion.answerKeyH = "";
      this.testQuestion.answerKeyI = "";
      this.testQuestion.answerKeyJ = "";
    }
  }
  blanksnumChange(value) {
    this.blanksnum = value;
    if (value < 2) {
      this.testQuestion.answerKeyF = "";
      this.testQuestion.answerKeyG = "";
      this.testQuestion.answerKeyH = "";
      this.testQuestion.answerKeyI = "";
      this.testQuestion.answerKeyJ = "";
    }
    if (value < 3) {
      this.testQuestion.answerKeyK = "";
      this.testQuestion.answerKeyL = "";
      this.testQuestion.answerKeyM = "";
      this.testQuestion.answerKeyN = "";
      this.testQuestion.answerKeyO = "";
    }
  }
  topicOne: any = [];
  topicTwo: any = [];
  uploadActin: string = url + "api/services/app/File/FileGetToken";
  token: string = "Bearer " + window.abp.auth.getToken();
  uploadList: any = [];
  uploadPdfList: any = [];
  questionContent: string = "";
  answerTips: string = "";
  answerKeyA: string = "";
  answerKeyB: string = "";
  answerKeyC: string = "";
  answerKeyD: string = "";
  answerKeyE: string = "";
  answerKeyF: string = "";
  answerKeyG: string = "";
  answerKeyH: string = "";
  answerKeyI: string = "";
  answerKeyJ: string = "";
  answerKeyK: string = "";
  answerKeyL: string = "";
  answerKeyM: string = "";
  answerKeyN: string = "";
  answerKeyO: string = "";
  uploadSuccess(res, file, fileList) {
    this.uploadList = fileList;
  }

  searchebutcount() {
    if (!this.keywords) {
      this.$Message.error("请输入试题内容");
      return false;
    }
    if (
      !this.testQuestion.questionType &&
      this.testQuestion.questionType !== 0
    ) {
      this.$Message.error("请选择试题类型");
      return false;
    }
    this.$store.state.testQuestion.editTestQuestion.questionType =
      this.testQuestion.questionType;
    this.$store.state.testQuestion.editTestQuestion.keyword = this.keywords;
    this.repeatModalShow = true;
  }




  setEditorDataInit() {
    (this.$refs["deconme"] as any).setHtmlewebQuesTion("");
    (this.$refs["answerTips"] as any).setHtmlewebQuesTion("");
    (this.$refs["answerKeyA"] as any).setHtmlewebQuesTion("");
    (this.$refs["answerKeyB"] as any).setHtmlewebQuesTion("");
    (this.$refs["answerKeyC"] as any).setHtmlewebQuesTion("");
    (this.$refs["answerKeyD"] as any).setHtmlewebQuesTion("");
    (this.$refs["answerKeyE"] as any).setHtmlewebQuesTion("");
    if (
      this.testQuestion.questionType == 1 ||
      this.testQuestion.questionType == 3
    ) {
      (this.$refs["answerKeyF"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyG"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyH"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyI"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyJ"] as any).setHtmlewebQuesTion("");
    }
    if (this.testQuestion.questionType == 3) {
      (this.$refs["answerKeyK"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyL"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyM"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyN"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyO"] as any).setHtmlewebQuesTion("");
    }
  }
  getQuestionContent() {
    this.testQuestion.questionContent = this.removefilterHtmlbr(
      this.removefilterHtmlp(this.testQuestion.questionContent)
    );
    this.testQuestion.answerTips = this.removefilterHtmlbr(
      this.removefilterHtmlp(this.testQuestion.answerTips)
    );
    if (this.testQuestion.questionType > 0) {
      this.testQuestion.answerKeyA = this.removefilterHtmlbr(
        this.removefilterHtmlp(this.testQuestion.answerKeyA)
      );
      this.testQuestion.answerKeyB = this.removefilterHtmlbr(
        this.removefilterHtmlp(this.testQuestion.answerKeyB)
      );
      this.testQuestion.answerKeyC = this.removefilterHtmlbr(
        this.removefilterHtmlp(this.testQuestion.answerKeyC)
      );
      this.testQuestion.answerKeyD = this.removefilterHtmlbr(
        this.removefilterHtmlp(this.testQuestion.answerKeyD)
      );
      this.testQuestion.answerKeyE = this.removefilterHtmlbr(
        this.removefilterHtmlp(this.testQuestion.answerKeyE)
      );
    }
    if (
      this.testQuestion.questionType == 1 ||
      this.testQuestion.questionType == 3
    ) {
      if (this.blanksnum >= 2 || this.choicenum == 2) {
        this.testQuestion.answerKeyF = this.removefilterHtmlbr(
          this.removefilterHtmlp(this.testQuestion.answerKeyF)
        );
        this.testQuestion.answerKeyG = this.removefilterHtmlbr(
          this.removefilterHtmlp(this.testQuestion.answerKeyG)
        );
        this.testQuestion.answerKeyH = this.removefilterHtmlbr(
          this.removefilterHtmlp(this.testQuestion.answerKeyH)
        );
        this.testQuestion.answerKeyI = this.removefilterHtmlbr(
          this.removefilterHtmlp(this.testQuestion.answerKeyI)
        );
        this.testQuestion.answerKeyJ = this.removefilterHtmlbr(
          this.removefilterHtmlp(this.testQuestion.answerKeyJ)
        );
      }
    }
    if (this.testQuestion.questionType == 3) {
      if (this.blanksnum > 2) {
        this.testQuestion.answerKeyK = this.removefilterHtmlbr(
          this.testQuestion.answerKeyK
        );
        this.testQuestion.answerKeyL = this.removefilterHtmlbr(
          this.testQuestion.answerKeyL
        );
        this.testQuestion.answerKeyM = this.removefilterHtmlbr(
          this.testQuestion.answerKeyM
        );
        this.testQuestion.answerKeyN = this.removefilterHtmlbr(
          this.testQuestion.answerKeyN
        );
        this.testQuestion.answerKeyO = this.removefilterHtmlbr(
          this.testQuestion.answerKeyO
        );
      }
    }
  }
  handleRemove(file, fileList) {
    this.uploadList = fileList;
  }

  handleMaxSize(file) {
    this.$Notice.warning({
      title: "超出文件大小限制",
      desc: "文件【" + file.name + "】 太大, 不能超过50M.",
    });
  }
  search() { }
  cascaderSelect(value, selectedData) {
    if (selectedData.length > 0) {
      if (selectedData[0].id == 1033) {
        this.newtabdata[0].display = false;
      }
      if (selectedData[0].id == 1026 || selectedData[0].id == 1027 || selectedData[0].id == 1028 || selectedData[0].id == 1029 || selectedData[0].id == 1030 || selectedData[0].id == 1031 || selectedData[0].id == 1032 || selectedData[0].id == 1033) {
        this.newtabdata[2].display = false;
      }
      if (selectedData[0].id == 1031) {
        this.newtabdata[3].display = false;
      }
      if (selectedData[0].id == 1026 || selectedData[0].id == 1028 || selectedData[0].id == 1030 || selectedData[0].id == 1031 || selectedData[0].id == 1032 || selectedData[0].id == 1033) {
        this.newtabdata[4].display = false;
      }
      if (selectedData[0].id == 1027 || selectedData[0].id == 1025 || selectedData[0].id == 1029 || selectedData[0].id == 1030 || selectedData[0].id == 1031 || selectedData[0].id == 1032 || selectedData[0].id == 1033) {
        this.newtabdata[6].display = false;
      }
      if (selectedData[0].id == 1028 || selectedData[0].id == 1033) {
        this.newtabdata[7].display = false;
      }
      if (selectedData[0].id == 1028 || selectedData[0].id == 1025 || selectedData[0].id == 1029 || selectedData[0].id == 1030 || selectedData[0].id == 1033) {
        this.newtabdata[8].display = false;
      }
      if (selectedData[0].id == 1028 || selectedData[0].id == 1025 || selectedData[0].id == 1029 || selectedData[0].id == 1030 || selectedData[0].id == 1033) {
        this.newtabdata[9].display = false;
      }

      this.testQuestion.sectionId = selectedData[selectedData.length - 1].id;
    }
    else {
      this.testQuestion.sectionId = null;
      this.newtabdata = [
        { value: 0, label: "判断题", display: true },
        { value: 1, label: "单选题", display: true },
        { value: 2, label: "多选题", display: true },
        { value: 3, label: "填空题", display: true },
        { value: 4, label: "计算题", display: true },
        { value: 8, label: "解答题", display: true },
        { value: 9, label: "作文题", display: true },
        { value: 10, label: "探究题", display: true },
        { value: 11, label: "材料题", display: true },
        { value: 12, label: "实践题", display: true },
        { value: 7, label: "选考单选", display: false },
        { value: 5, label: "选考多选", display: false },
        { value: 6, label: "选考计算", display: false },
      ];
    }
  }
  save() {
    (this.$refs.testQuestionForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.valueArray.length > 0) {
          if (this.valueArray.length < 4) {
            this.$Message.warning("学科未选择到末级!");
            return false;
          }
        } else {
          this.$Message.warning("请选择试题学科");
          return false;
        }
        if (!this.testQuestion.degreeDifficulty) {
          this.$Message.warning("请选择试题难度");
          return false;
        }
        if (
          !this.testQuestion.questionType &&
          this.testQuestion.questionType !== 0
        ) {
          this.$Message.warning("请选择试题类型");
          return false;
        }
        this.getQuestionContent();
        if (
          this.testQuestion.questionType == 1 ||
          this.testQuestion.questionType == 2 ||
          this.testQuestion.questionType == 5 ||
          this.testQuestion.questionType == 7
        ) {
          if (
            this.testQuestion.questionType == 1 ||
            this.testQuestion.questionType == 7
          ) {
            this.testQuestion.correctAnswer = this.keytype;
          } else {
            this.testQuestion.correctAnswer = this.keychecktype.sort().join(",");
          }

        } else {
          if (
            !this.testQuestion.answerKeyA &&
            this.testQuestion.questionType != 0
          ) {
            this.$Message.warning("至少有一个答案，并从第一个开始");
            return false;
          } else if (this.testQuestion.questionType == 0) {
            this.testQuestion.correctAnswer = this.onequestype;
          } else {
            this.testQuestion.correctAnswer = this.testQuestion.answerKeyA;
          }
          if (this.testQuestion.answerKeyB) {
            this.testQuestion.correctAnswer +=
              "\r\n" + this.testQuestion.answerKeyB;
          }
          if (this.testQuestion.answerKeyC) {
            this.testQuestion.correctAnswer +=
              "\r\n" + this.testQuestion.answerKeyC;
          }
          if (this.testQuestion.answerKeyD) {
            this.testQuestion.correctAnswer +=
              "\r\n" + this.testQuestion.answerKeyD;
          }
          if (this.testQuestion.answerKeyE) {
            this.testQuestion.correctAnswer +=
              "\r\n" + this.testQuestion.answerKeyE;
          }
          if (this.testQuestion.questionType == 3) {
            //填空题 正确答案后10空
            if (this.testQuestion.answerKeyF) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyF;
            }
            if (this.testQuestion.answerKeyG) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyG;
            }
            if (this.testQuestion.answerKeyH) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyH;
            }
            if (this.testQuestion.answerKeyI) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyI;
            }
            if (this.testQuestion.answerKeyJ) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyJ;
            }
            if (this.testQuestion.answerKeyK) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyK;
            }
            if (this.testQuestion.answerKeyL) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyL;
            }
            if (this.testQuestion.answerKeyM) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyM;
            }
            if (this.testQuestion.answerKeyN) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyN;
            }
            if (this.testQuestion.answerKeyO) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyO;
            } //填空题 正确答案后10空
          }
        }

        if (!this.testQuestion.questionContent) {
          this.$Message.warning("请填写试题内容");
          return false;
        }
        if (!this.testQuestion.answerKeyA && this.testQuestion.questionType) {
          this.$Message.warning("请填写答案内容");
          return false;
        }
        if (this.testQuestion.questionType == 0) {
          if (!this.onequestype) {
            this.$Message.warning("请设置正确答案");
            return false;
          }
        }
        if (
          this.testQuestion.questionType == 1 ||
          this.testQuestion.questionType == 2 ||
          this.testQuestion.questionType == 5 ||
          this.testQuestion.questionType == 7
        ) {
          if (
            !this.testQuestion.correctAnswer ||
            this.testQuestion.correctAnswer.length < 1
          ) {
            this.$Message.warning("请设置正确答案");
            return false;
          }
        }
        if (
          this.testQuestion.questionType == 2 ||
          this.testQuestion.questionType == 5
        ) {
          if (this.testQuestion.correctAnswer.length < 3) {
            this.$Message.warning("请至少选择两个正确答案");
            return false;
          }
        }
        this.testQuestion.gradeType = 0;
        let sendType = "testQuestion/create";
        if (!this.isCreate) {
          sendType = "testQuestion/update";
        }
        this.$store
          .dispatch({
            type: sendType,
            data: this.testQuestion,
          })
          .then((result) => {
            if (this.isCreate) {
              this.testQuestion.degreeDifficulty = 0;
              this.keytype = "";
              this.keychecktype = [];
              this.onequestype = "";
              this.testQuestion.questionContent = "";
              this.testQuestion.answerTips = "";
              if (this.testQuestion.questionType > 0) {
                this.testQuestion.correctAnswer = "";
                this.testQuestion.answerKeyA = "";
                this.testQuestion.answerKeyB = "";
                this.testQuestion.answerKeyC = "";
                this.testQuestion.answerKeyD = "";
                this.testQuestion.answerKeyE = "";
                if (this.blanksnum >= 2 || this.choicenum == 2) {
                  this.testQuestion.answerKeyF = "";
                  this.testQuestion.answerKeyG = "";
                  this.testQuestion.answerKeyH = "";
                  this.testQuestion.answerKeyI = "";
                  this.testQuestion.answerKeyJ = "";
                }
                if (this.blanksnum > 2) {
                  this.testQuestion.answerKeyK = "";
                  this.testQuestion.answerKeyL = "";
                  this.testQuestion.answerKeyM = "";
                  this.testQuestion.answerKeyN = "";
                  this.testQuestion.answerKeyO = "";
                }
              } else {
                this.testQuestion.correctAnswer = "";
              }
              this.testQuestion.questionType = undefined;
            } else {
              this.testQuestion.correctAnswer = "";
              (this.$refs.testQuestionForm as any).resetFields();
              this.$emit("save-success");
              this.$emit("input", false);
            }
          });
      }
    });
  }

  cancel() {
    this.visibleChange(false);
  }
  visibleChange(value: boolean) {
    this.choicenum = 1;
    this.blanksnum = 1;
    if (!value) {
      this.testQuestion = new TestQuestion();
      this.$store.state.testQuestion.editTestQuestion = this.testQuestion;
      (this.$refs.testQuestionForm as any).resetFields();
      this.newtabdata = [
        { id: 0, value: "判断题", display: true },
        { id: 1, value: "单选题", display: true },
        { id: 2, value: "多选题", display: true },
        { id: 3, value: "填空题", display: true },
        { id: 4, value: "计算题", display: true },
        { id: 8, value: "解答题", display: true },
        { id: 9, value: "作文题", display: true },
        { id: 10, value: "探究题", display: true },
        { id: 11, value: "材料题", display: true },
        { id: 12, value: "实践题", display: true },
        { id: 7, value: "选考单选", display: false },
        { id: 5, value: "选考多选", display: false },
        { id: 6, value: "选考计算", display: false },
      ]
      if (this.isCreate) this.$emit("save-success");
      this.$emit("input", value);
    } else {
      this.data = this.$store.state.testQuestion.cascaders.items;
      this.testQuestion = Util.extend(
        true,
        {},
        this.$store.state.testQuestion.editTestQuestion
      );
      this.valueArray = this.testQuestion.categoryList;
      if (this.testQuestion.id) {

        if (this.testQuestion.categoryList[0] == 1033) {

          this.newtabdata[0].display = false;
        }
        if (this.testQuestion.categoryList[0] == 1026 || this.testQuestion.categoryList[0] == 1027 || this.testQuestion.categoryList[0] == 1028 || this.testQuestion.categoryList[0] == 1029 || this.testQuestion.categoryList[0] == 1030 || this.testQuestion.categoryList[0] == 1031 || this.testQuestion.categoryList[0] == 1032 || this.testQuestion.categoryList[0] == 1033) {

          this.newtabdata[2].display = false;
        }
        if (this.testQuestion.categoryList[0] == 1031) {

          this.newtabdata[3].display = false;
        }
        if (this.testQuestion.categoryList[0] == 1026 || this.testQuestion.categoryList[0] == 1028 || this.testQuestion.categoryList[0] == 1030 || this.testQuestion.categoryList[0] == 1031 || this.testQuestion.categoryList[0] == 1032 || this.testQuestion.categoryList[0] == 1033) {

          this.newtabdata[4].display = false;
        }
        if (this.testQuestion.categoryList[0] == 1027 || this.testQuestion.categoryList[0] == 1025 || this.testQuestion.categoryList[0] == 1029 || this.testQuestion.categoryList[0] == 1030 || this.testQuestion.categoryList[0] == 1031 || this.testQuestion.categoryList[0] == 1032 || this.testQuestion.categoryList[0] == 1033) {

          this.newtabdata[6].display = false;
        }
        if (this.testQuestion.categoryList[0] == 1028 || this.testQuestion.categoryList[0] == 1033) {

          this.newtabdata[7].display = false;
        }
        if (this.testQuestion.categoryList[0] == 1028 || this.testQuestion.categoryList[0] == 1025 || this.testQuestion.categoryList[0] == 1029 || this.testQuestion.categoryList[0] == 1030 || this.testQuestion.categoryList[0] == 1033) {

          this.newtabdata[8].display = false;
        }
        if (this.testQuestion.categoryList[0] == 1028 || this.testQuestion.categoryList[0] == 1025 || this.testQuestion.categoryList[0] == 1029 || this.testQuestion.categoryList[0] == 1030 || this.testQuestion.categoryList[0] == 1033) {

          this.newtabdata[9].display = false;
        }

        this.isCreate = false;
        this.formTitle = "修改试题";
        this.keytype = this.testQuestion.correctAnswer;
        this.keychecktype = this.testQuestion.listAnswer;
        this.onequestype = this.testQuestion.correctAnswer;
        this.questionContent = this.testQuestion.questionContent;
        this.answerTips = this.testQuestion.answerTips;
        this.testQuestion.isAudit = this.testQuestion.isAudit.toString();

        if (this.testQuestion.questionType > 0) {
          if (this.testQuestion.answerKeyA === null) {
            this.testQuestion.answerKeyA = "";
          } else {
            this.testQuestion.answerKeyA = this.testQuestion.answerKeyA;
          }
          if (this.testQuestion.answerKeyB === null) {
            this.testQuestion.answerKeyB = "";
          } else {
            this.testQuestion.answerKeyB = this.testQuestion.answerKeyB;
          }
          if (this.testQuestion.answerKeyC === null) {
            this.testQuestion.answerKeyC = "";
          } else {
            this.testQuestion.answerKeyC = this.testQuestion.answerKeyC;
          }
          if (this.testQuestion.answerKeyD === null) {
            this.testQuestion.answerKeyD = "";
          } else {
            this.testQuestion.answerKeyD = this.testQuestion.answerKeyD;
          }
          if (this.testQuestion.answerKeyE === null) {
            this.testQuestion.answerKeyE = "";
          } else {
            this.testQuestion.answerKeyE = this.testQuestion.answerKeyE;
          }
          //试题为单选或者填空时编辑器内容赋值
          if (
            this.testQuestion.questionType == 1 ||
            this.testQuestion.questionType == 3
          ) {
            if (
              this.testQuestion.answerKeyF === null ||
              !this.testQuestion.answerKeyF
            ) {
              this.answerKeyF = "";
            } else {
              this.answerKeyF = this.testQuestion.answerKeyF;
              this.choicenum = 2;
              this.blanksnum = 2;
            }
            if (
              this.testQuestion.answerKeyG === null ||
              !this.testQuestion.answerKeyG
            ) {
              this.answerKeyG = "";
            } else {
              this.answerKeyG = this.testQuestion.answerKeyG;
              this.choicenum = 2;
              this.blanksnum = 2;
            }
            if (
              this.testQuestion.answerKeyH === null ||
              !this.testQuestion.answerKeyH
            ) {
              this.answerKeyH = "";
            } else {
              this.answerKeyH = this.testQuestion.answerKeyH;
              this.choicenum = 2;
              this.blanksnum = 2;
            }
            if (
              this.testQuestion.answerKeyI === null ||
              !this.testQuestion.answerKeyI
            ) {
              this.answerKeyI = "";
            } else {
              this.answerKeyI = this.testQuestion.answerKeyI;
              this.choicenum = 2;
              this.blanksnum = 2;
            }
            if (
              this.testQuestion.answerKeyJ === null ||
              !this.testQuestion.answerKeyJ
            ) {
              this.answerKeyJ = "";
            } else {
              this.answerKeyJ = this.testQuestion.answerKeyJ;
              this.choicenum = 2;
              this.blanksnum = 2;
            }
          }
          if (this.testQuestion.questionType == 3) {
            if (
              this.testQuestion.answerKeyK === null ||
              !this.testQuestion.answerKeyK
            ) {
              this.answerKeyK = "";
            } else {
              this.answerKeyK = this.testQuestion.answerKeyK;
              this.blanksnum = 3;
            }
            if (
              this.testQuestion.answerKeyL === null ||
              !this.testQuestion.answerKeyL
            ) {
              this.answerKeyL = "";
            } else {
              this.answerKeyL = this.testQuestion.answerKeyL;
              this.blanksnum = 3;
            }
            if (
              this.testQuestion.answerKeyM === null ||
              !this.testQuestion.answerKeyM
            ) {
              this.answerKeyM = "";
            } else {
              this.answerKeyM = this.testQuestion.answerKeyM;
              this.blanksnum = 3;
            }
            if (
              this.testQuestion.answerKeyN === null ||
              !this.testQuestion.answerKeyN
            ) {
              this.answerKeyN = "";
            } else {
              this.answerKeyN = this.testQuestion.answerKeyN;
              this.blanksnum = 3;
            }
            if (
              this.testQuestion.answerKeyO === null ||
              !this.testQuestion.answerKeyO
            ) {
              this.answerKeyO = "";
            } else {
              this.answerKeyO = this.testQuestion.answerKeyO;
              this.blanksnum = 3;
            }
          }




        }

      } else {
        this.isCreate = true;
        this.formTitle = "增加试题";
        this.createInit();
        //   this.setEditorDataInit();
      }
    }
  }
  async created() {
    this.visibleChange(true);
  }
  createInit() {
    // (this.$refs.testQuestionForm as any).resetFields();
    if (this.testQuestion.sisterId === "") this.valueArray = [];
    this.keytype = "";
    this.keychecktype = [];
  }
}
